<div class="container-fluid px-2">
  <div class="card analytics-card mt-4" *ngIf="!loading && groupedStats.length > 0">
    <div class="card-body">
      <h4 class="card-title mb-3 text-center text-md-start">Game Statistics by State</h4>

      <div class="table-responsive-sm overflow-auto d-block" style="max-width: 100vw;">
        <table class="table table-sm table-bordered table-hover">
          <thead class="table-light">
            <tr class="text-nowrap">
              <th>State</th>
              <th>Scanned Boards</th>
              <th>Assigned Boards</th>
              <th>Total Cash In</th>
              <th>Total Cash Out</th>
              <th>Net</th>
              <th>$ In/Day</th>
              <th>Net/Day</th>
              <th>Payout %</th>
              <th>RPT</th>
              <th>Turnover</th>
              <th>Credit Won</th>
              <th>Games Played</th>
              <th>Games Won</th>
              <th>Bet Mult</th>
              <th>Bet/Play</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let entry of groupedStats">
              <!-- Summary Row -->
              <tr *ngIf="entry?.stats">
                <td><strong>{{ entry.state }}</strong></td>
                <td>
                  <a href="#" (click)="toggleState(entry.state); $event.preventDefault()">
                    {{ entry.stats.count }}
                  </a>
                </td>
                <td>
                  {{ getAssignedBoardCount(entry.state) }}
                </td>
                <td>{{ entry.stats.totalCashin | number:'1.0-0' }}</td>
                <td>{{ entry.stats.totalCashout | number:'1.0-0' }}</td>
                <td>{{ entry.stats.totalNet | number:'1.0-0' }}</td>
                <td>{{ getCashInPerDay(entry.stats) | number:'1.2-2' }}</td>
                <td>{{ getNetPerDay(entry.stats) | number:'1.2-2' }}</td>
                <td>{{ entry.stats.payoutRatio * 100 | number:'1.1-1' }}%</td>
                <td>{{ entry.stats.rpt * 100 | number:'1.1-1' }}%</td>
                <td>{{ entry.stats.totalCoinIn | number:'1.0-0' }}</td>
                <td>{{ entry.stats.totalCoinOut | number:'1.0-0' }}</td>
                <td>{{ entry.stats.totalGamesPlayed | number:'1.0-0' }}</td>
                <td>{{ entry.stats.totalGamesWon | number:'1.0-0' }}</td>
                <td>{{ entry.stats.betMultiplier | number:'1.2-2' }}</td>
                <td>{{ entry.stats.betPerPlay | number:'1.2-2' }}</td>
              </tr>

              <!-- Expanded Board-Level Table -->
              <tr *ngIf="isExpanded(entry.state)">
                <td colspan="15">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered mb-0">
                      <thead class="table-light">
                        <tr class="text-nowrap">
                          <th>Location</th>
                          <th>Game</th>
                          <th>Cash In</th>
                          <th>Cash Out</th>
                          <th>Net</th>
                          <th>Days</th>
                          <th>$ In/Day</th>
                          <th>Net/Day</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let stat of entry.stats.rawStats">
                          <td>{{ stat.board?.currentDeployment?.location?.locationName }}</td>
                          <td>{{ stat.board?.installedGamePackage?.name }}</td>
                          <td>{{ stat.cashInDiff | number:'1.0-0' }}</td>
                          <td>{{ stat.cashOutDiff | number:'1.0-0' }}</td>
                          <td>{{ stat.profit | number:'1.0-0' }}</td>
                          <td>{{ stat.daysSincePrevRead }}</td>
                          <td>
                            {{
                              (stat.daysSincePrevRead > 0
                                ? (stat.cashInDiff / stat.daysSincePrevRead)
                                : 0) | number:'1.2-2'
                            }}
                          </td>
                          <td>
                            {{
                              (stat.daysSincePrevRead > 0
                                ? (stat.profit / stat.daysSincePrevRead)
                                : 0) | number:'1.2-2'
                            }}
                          </td>
                        </tr>

                        <!-- Board-Level Total per State -->
                        <tr class="table-light fw-bold">
                          <td>Total</td>
                          <td></td>
                          <td>{{ getTotalForState(entry.stats.rawStats, 'cashInDiff') | number:'1.0-0' }}</td>
                          <td>{{ getTotalForState(entry.stats.rawStats, 'cashOutDiff') | number:'1.0-0' }}</td>
                          <td>{{ getTotalForState(entry.stats.rawStats, 'profit') | number:'1.0-0' }}</td>
                          <td>{{ getTotalForState(entry.stats.rawStats, 'daysSincePrevRead') }}</td>
                          <td>
                            {{
                              getTotalForState(entry.stats.rawStats, 'cashInDiff') /
                              getTotalForState(entry.stats.rawStats, 'daysSincePrevRead') | number:'1.2-2'
                            }}
                          </td>
                          <td>
                            {{
                              getTotalForState(entry.stats.rawStats, 'profit') /
                              getTotalForState(entry.stats.rawStats, 'daysSincePrevRead') | number:'1.2-2'
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </ng-container>

            <!-- Grand Total Row -->
            <tr class="table-primary fw-bold">
            <td>Grand Total</td>
            <td>{{ getGrandTotal().count }}</td>
            <td>
              {{ getTotalAssignedBoards() }}
            </td>
            <td>{{ getGrandTotal().totalCashin | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalCashout | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalNet | number:'1.0-0' }}</td>
            <td>{{ getCashInPerDay(getGrandTotal()) | number:'1.2-2' }}</td>
            <td>{{ getNetPerDay(getGrandTotal()) | number:'1.2-2' }}</td>
            <td>{{ getGrandTotal().payoutRatio * 100 | number:'1.1-1' }}%</td>
            <td>{{ getGrandTotal().rpt * 100 | number:'1.1-1' }}%</td>
            <td>{{ getGrandTotal().totalCoinIn | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalCoinOut | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalGamesPlayed | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalGamesWon | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().betMultiplier | number:'1.2-2' }}</td>
            <td>{{ getGrandTotal().betPerPlay | number:'1.2-2' }}</td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
